import React from "react";

const STAR_PATH =
  "M12 2.5l2.9 5.9 6.5.95-4.7 4.58 1.1 6.47L12 17.3l-5.8 3.1 1.1-6.47L2.6 9.35l6.5-.95z";

const buildIconProps = (size) => ({
  width: size,
  height: size,
  viewBox: "0 0 24 24",
  "aria-hidden": true,
});

/**
 * Outline star icon (task is not starred).
 *
 * @example
 * <ActionItemStarIcon size={14} />
 */
export const ActionItemStarIcon = ({ size = 14 }) => (
  <svg
    {...buildIconProps(size)}
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="round"
  >
    <path d={STAR_PATH} />
  </svg>
);

/**
 * Filled star icon (task is starred).
 *
 * @example
 * <ActionItemStarFilledIcon size={14} />
 */
export const ActionItemStarFilledIcon = ({ size = 14 }) => (
  <svg
    {...buildIconProps(size)}
    fill="currentColor"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinejoin="round"
  >
    <path d={STAR_PATH} />
  </svg>
);
